import React, { useState } from 'react';
import { Container, Typography, useTheme } from '@mui/material';
import { Calendar, SlotInfo, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';

//
import moment from 'moment';
import 'moment/locale/de';

import { computed } from 'mobx';

import AddReservationModal, {
  CalendarEvent,
} from '../dialog/AddReservationModal';
import useReservations from '../../hooks/useReservations';
import useMedia from '../../hooks/useMedia';

interface ReservationsProps {
  customerId: number;
}

const Reservations = ({ customerId }: ReservationsProps): JSX.Element => {
  // custom hook
  const { reservations, reservationPossiblities, getReservations } =
    useReservations(customerId);

  const [open, setOpen] = useState(false);

  const [currentSlot, setCurrentSlot] = useState<SlotInfo>();

  const [clickedCalenderEvent, setClickedCalenderEvent] =
    useState<CalendarEvent>();

  const localizer = momentLocalizer(moment);
  moment.locale('de'); // Set moment locale to German

  const { palette } = useTheme();
  const isMobile = useMedia('md');

  const refetchReservations = async () => {
    await getReservations();
  };

  const handleSelect = (event: CalendarEvent) => {
    setClickedCalenderEvent(event);
    setOpen(true);
  };

  const events = computed(() =>
    reservations?.map(reservation => ({
      id: reservation.reservierungs_id,
      title: reservation.text,
      start: new Date(reservation.beginn),
      end: new Date(reservation.ende),
      allDay: false,
      roomId: reservation.reservierungs_moeglichkeits_id,
      roomOccupancy: reservation.belegung,
      top_nutzer_id: reservation.top_nutzer_id,
    })),
  ).get();

  const selectSlot = async (slotInfo: SlotInfo) => {
    setCurrentSlot(slotInfo);
    setOpen(true);
  };
  const handleClosed = () => {
    setOpen(false);
    setClickedCalenderEvent(undefined);
    setCurrentSlot(undefined);
  };

  return (
    <Container>
      <Typography sx={{ marginBottom: 2 }} variant="h4" color="secondary">
        Kalender
      </Typography>
      <Calendar
        localizer={localizer}
        culture="de-DE"
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 700, color: '#58585A' }}
        onSelectEvent={event => handleSelect(event)}
        onSelectSlot={selectSlot}
        selectable
        messages={{
          next: 'weiter',
          previous: 'zurück',
          today: 'Heute',
          month: 'Monat',
          week: 'Woche',
          day: 'Tag',
          date: 'Datum',
          time: 'Zeit',
          event: 'Reservierung',
          showMore: total => (isMobile ? ` + ${total}` : `+ ${total} weitere`),
        }}
        eventPropGetter={event => {
          const backgroundColor = palette.primary.main;
          if (event.top_nutzer_id === customerId) {
            return { style: { backgroundColor } };
          }
          return { style: { backgroundColor: '#58585A' } };
        }}
      />
      {(currentSlot || clickedCalenderEvent) && (
        <AddReservationModal
          open={open}
          onClose={handleClosed}
          reservationsPossiblities={reservationPossiblities || []}
          customerId={Number(customerId) || 0}
          initialData={clickedCalenderEvent}
          currentSlot={currentSlot}
          onRefetch={refetchReservations}
        />
      )}
    </Container>
  );
};

export default Reservations;
